import z from "zod";

const zStatusSchema = z.enum(["NEW", "IN_PROGRESS", "ASSIGNED", "COMPLETED", "CANCELLED"]);
const StatusSchema = zStatusSchema.Enum;
type StatusSchema = z.infer<typeof zStatusSchema>;

const DEFAULT_STATUS = StatusSchema.NEW;

export { DEFAULT_STATUS, StatusSchema as Status, StatusSchema, zStatusSchema };
